import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Cell from './Cell';
import Container from './Container';

const Grid = ({ children, className, isCentered, ...otherProps }) => {
  const classes = classnames('Grid', className, {
    'Grid--centered': isCentered,
  });

  return (
    <div className={classes} {...otherProps}>
      {children}

      <style jsx>
        {`
          .Grid {
            display: flex;
            width: 100%;
            flex-flow: row wrap;
            margin: 0 auto;
          }

          .Grid--centered {
            justify-content: center;
          }
        `}
      </style>
    </div>
  );
};

Grid.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  isCentered: PropTypes.bool,
};

Grid.defaultProps = {
  isCentered: false,
  className: '',
};

export { Container, Cell, Grid };
